<template>
  <div class="center-situation">
    <div class="teaching_activity project-progress">
      <el-tabs v-model="activeName">
        <el-tab-pane label="综合评价" name="first">
          <div class="activity-home">
            <div class="table_section">
              <el-table :data="tableData" border>
                <el-table-column prop="number" label="序号" width="80" align="center" type="index">
                </el-table-column>
                <el-table-column prop="name" label="报告名称" width="600" align="center">
                </el-table-column>
                <el-table-column prop="date" label="日期" width="250" align="center">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block page_size">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page.sync="pagination.currentPage" :page-sizes="[10, 20, 50]"
                  :page-size="pagination.pagesize" layout="prev, pager, next,sizes" :total="pagination.total">
                </el-pagination>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  export default {
    inject: ['reload'],
    data() {
      return {
        tableData: [{
          // name:'2020-2021学年上学期综合评价报告',
          name: '三科统编教材中部四盟市教师专项培训报告',
          date: '2020.12.01',
        }],
        formInline: {
          type: "",
          time: "",
          search: ""
        },
        value1: "",
        pagination: { //分页
          currentPage: 1,
          pagesize: 10,
          total: 0,
        },
        typeList: [], //课程类型列表
        projectList: [{
          name: '综合评价',
          id: '1'
        }], //项目列表
        activeName: 'first', //当前项目
      };
    },
    computed: {},
    methods: {
      // 改变每页条数
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pagination.currentPage = 1;
        this.pagination.pagesize = val
        this.getPublicList();
      },
      // 翻页
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pagesize.currentPage = val;
        this.getPublicList();
      },
      // 查看点击
      handleClick(tab, event) {
        // console.log(tab, event);
        let role = this.$sotre.state.user.role
        let path = role === 'teacher' ? 'teacher/1' : role === 'student' ? 'student/1' : ''
        this.$router.push({
          path: `/evaluateDetail/${path}`,
        })

      }
    },
    mounted() {},
    activated() {}
  };
</script>

<style lang="less" soped>
  .teaching_activity {
    box-sizing: border-box;
    margin-bottom: 100px;
    max-width: 1200px;
    // padding: 35px 30px 50px;

    /deep/.el-table__row .el-table td,
    .el-table th.is-leaf {
      border-bottom: 0 !important;
    }

    .activity-home {
      padding: 0px 30px 50px;
    }

    .el-form-item__label {
      font-size: 16px;
      color: #595959;
    }

    .el-form-item {
      margin-right: 20px;

      .el-input__inner {
        border: 1px solid #858585;
        border-radius: 2px;
        color: #343434;
      }

      .el-input .el-select__caret {
        color: #343434;
      }

      .el-input__inner::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #343434;
      }

      .el-input__inner::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #343434;
      }

      .el-input__inner:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #343434;
      }
    }

    .el-form-item__content {
      .el-select {
        .el-input--suffix {
          max-width: 116px;

          .el-input__inner {
            height: 30px;
            line-height: 30px;
          }
        }
      }

      .el-input {
        width: 260px;

        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
      }
    }

    .form-inline-item {
      margin-right: 30px;

      i {
        vertical-align: sub;
        margin-right: 10px;
        font-size: 24px;
        font-weight: bold;
        color: #2373ec;
      }

      span {
        font-size: 18px;

        color: #5a5a5a;
      }
    }
  }

  .el-pager {
    .number {
      height: 32px;
      border: 1px solid #dfdfdf;
      border-radius: 4px;
      margin: 0 5px;
    }

    li.active {
      background: #2573ed;
      color: #fff;
    }

    & li.active+li {
      border-left: 1px solid #dfdfdf;
    }
  }

  .page_size {
    text-align: right;
    padding: 20px 0;
  }

  .table-section {
    margin-top: 30px;
  }

  .el-table {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .el-table__header {
    thead th {
      color: #fff;
      background-color: rgba(35, 115, 236, 0.76);
      border: 0;
    }
  }

  @media screen and (max-width: 1299px) {
    .teaching_public {
      width: 1100px;
    }
  }

  @media screen and (max-width: 1199px) {
    .teaching_public {
      width: 990px;
    }
  }

  @media screen and (max-width: 1099px) {
    .teaching_public {
      width: 990px;
    }
  }

  .center-situation {
    // margin-left:38px;
    // width: 1200px;
    margin-left: 38px;
    min-width: 990px;
    max-width: 1200px;
  }

  @media screen and (max-width: 1600px) {
    .center-situation {
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 1400px) {
    .center-situation {
      margin: 0 50px 0 80px;
    }
  }
</style>